import Phaser from 'phaser';
import { updateHudViewport } from './hud-viewport';
import type { HudScene } from './scenes/HudScene';

export function getVisibleGameViewport(game: Phaser.Game) {
  return game.scale.getViewPort();
}

export function syncHudViewport(game: Phaser.Game) {
  updateHudViewport(game);
  const hud = game.scene.getScene('HudScene') as HudScene | null;
  if (hud?.hudRoot) hud.applyViewportLayout();

  const ui = game.scene.getScene('UiScene') as { applyViewportLayout?: () => void } | null;
  ui?.applyViewportLayout?.();
}

/** Keep fixed HUD aligned to the on-screen safe area when scale mode crops. */
export function bindHudViewportFit(game: Phaser.Game) {
  if (!game?.scale) return () => {};

  const sync = () => syncHudViewport(game);

  game.scale.on('resize', sync);
  game.events.once('ready', sync);

  return sync;
}
